<template>

    <div class="table-responsive">

        <slot v-if="! loaded" name="table-loading">
            <sau-loading>
                <template slot="message">Finding records</template>
            </sau-loading>
        </slot>

        <template v-else>

            <slot v-if="data.length === 0" name="table-empty">
                <sau-apiro-response type="message">
                    <template slot="message">No records to display.</template>
                </sau-apiro-response>
            </slot>


            <template v-else>
                <table id="sau-dynamic-table" class="table sau-dynamic-table" :class="{ 'collapse' : collapse }">

                    <thead class="text-sm sau-font-bold">
                        <slot name="table-header"></slot>
                    </thead>

                    <tbody>
                        <template v-for="item in paginatedData">
                            <slot v-bind:item="item"></slot>
                        </template>
                    </tbody>
                </table>

                <div v-if="config.paginator.enabled" class="sau-paginator mt-6">
                    <p class="text-right text-sm">{{ start === 0 ? 1 : start }} to {{ end }} of {{ data.length }}</p>

                    <div class="flex mt-12" v-if="data.length >= config.paginator.itemsPerPage">
                        <b-pagination
                            v-on:input="changePageAndScroll"
                            v-model="config.paginator.page"
                            :total-rows="data.length"
                            :per-page="config.paginator.itemsPerPage"
                            :hide-goto-end-buttons="true"
                            class="mx-auto"
                            >
                        </b-pagination>
                    </div>
                </div>
            </template>
        </template>
    </div>
</template>

<script>

    export default {

        props: {
            config: {
                type: Object,
                required: false,
                default() {
                    return {
                        paginator: {
                            enabled: true,
                            itemsPerPage: 25,
                            page: 1,
                        },
                        search: {
                            enabled: true,
                            term: '',
                        },
                    }
                }
            },
            data: {
                type: Array,
                required: true,
            },
            loaded: {
                type: Boolean,
                required: false,
                default() {
                    return true;
                }
            },
            collapse: {
                type: Boolean,
                required: false,
                default() {
                    return false;
                },
            }
        },

        data() {
            return {
                start: 0,
                end: 0,
                disableScroll: false
            }
        },
        mounted() {
            window.bus.$on('paginator-reset', () => this.changePage(1));
        },
        methods: {
            search(term) {
                this.config.search.term = term;
            },

            changePage(page, scroll = false) {
                this.config.paginator.page = page;

                // 💩 Because vue paginator considers @input to take place on changing the search results
                if (scroll && ! this.disableScroll) {
                    this.scrollToTopOfTable();
                } else {
                    this.disableScroll = true;
                    this.$nextTick(() => this.disableScroll = false);
                }
            },

            changePageAndScroll(page) {
                this.changePage(page, true);
            },

            scrollToTopOfTable() {
                window.scrollTo({
                    top: document.getElementById('sau-dynamic-table').offsetTop,
                    behavior: 'smooth',
                });
            }
        },

        computed: {
            paginatedData: function() {
                this.start = this.config.paginator.page === 1
                    ? 0
                    : (this.config.paginator.page - 1) * this.config.paginator.itemsPerPage;

                this.end = this.start + this.config.paginator.itemsPerPage > this.data.length
                    ? this.data.length
                    : this.start + this.config.paginator.itemsPerPage;

                return this.data.slice(this.start, this.end);
            }
        },
    }
</script>
<style scoped lang="scss">
    thead {
        color: #999999;

        th {
            border-top: 0;
        }
    }

    .sau-dynamic-table {

        select {
            background: none;
            color: #00ce7d;
            /* browser resets */
            margin: 0;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;

            /* custom arrow */
            background: #fff url('/img/chevron-down-success.svg') no-repeat;
            background-size: 20px;
            background-position:  right center;
            padding-right: 30px;
        }

    }


</style>
<style lang="scss">

    .sau-paginator {

        li:first-of-type,
        li:last-of-type {
            font-size: 1.75rem;
            line-height: 1.75rem;

            a,
            span {
                padding-top: 0;
                padding-bottom: 0;
            }
        }
        * {
            border: none !important;
        }
        li {
            a {
                border-radius: 50%;

                &:focus {
                    box-shadow: none;
                }
            }
            &:not(.active) {
                &:hover {
                    text-decoration: underline;
                }
            }
        }
        .page-link {
            margin-left: 0;
        }
        .page-item:not(.active) {
            .page-link {
                &:hover {
                    background-color: transparent;
                }
            }
        }
    }
</style>
<style scoped>
    @media (max-width: 575px)
    {
        .sau-dynamic-table.collapse thead {
            display: none !important;
        }
        .sau-dynamic-table.collapse tr {
            display: grid;
            grid-template-columns: minmax(66%, 100%) minmax(0, 100%);
            grid-template-areas: "a c" "b c";
            width: 100%;
            border-bottom: solid 1px #c9c9c9;
            padding: 0.5rem 0;
        }
        .sau-dynamic-table.collapse td {
            border: none;
            padding: 0;
            word-wrap: break-all;
        }
        .sau-dynamic-table.collapse i {
            font-size: 1.5rem !important;
        }
        .sau-dynamic-table.collapse tr td:first-of-type {
            grid-area: a;
        }
        .sau-dynamic-table.collapse tr td:nth-of-type(2) {
            grid-area: b;
            font-size: 0.875rem;
        }
        .sau-dynamic-table.collapse tr td:last-of-type {
            grid-area: c;
            align-self: center;
            justify-self: center;
        }
    }
</style>